import React, { useContext } from "react";
import styled from "styled-components";
// Components
import ProjectBox from "../Elements/ProjectBox";
// Assets
import ProjectImg1 from "../../assets/img/1.png";
import ProjectImg2 from "../../assets/img/2.png";
import ProjectImg3 from "../../assets/img/3.png";
import ProjectImg6 from "../../assets/img/6.png";
import ProjectImg7 from "../../assets/img/7.png";
import ProjectImg8 from "../../assets/img/8.png";
import ProjectImg9 from "../../assets/img/9.png";
import ProjectImg10 from "../../assets/img/10.png";
import ProjectImg11 from "../../assets/img/11.png";
import ProjectImg12 from "../../assets/img/12.png";
import ProjectImg13 from "../../assets/img/13.png";
import ProjectImg14 from "../../assets/img/14.png";
import { LanguageContext } from "../../screens/LanguageContext";  // Import the context

export default function Projects() {
  const { language } = useContext(LanguageContext); // Access the language context

  // Translations based on selected language
  const translations = {
    en: {
      title: "Our Packaging Excellence",
      description:
        "Discover a range of innovative packaging solutions, from high-quality plastic bags to advanced lamination rolls. We cater to diverse industries with precision and sustainability in mind.",
      project1: "Garbage Bags",
      project1Desc: "High-quality garbage bags in various sizes and colors for residential and commercial use.",
      project2: "Printed Plastic Bags",
      project2Desc: "Custom printed plastic bags with zippers for food and other products.",
      project3: "Garbage Rolls",
      project3Desc: "Garbage rolls with all sizes and colors for residential and commercial use.",
      project4: "Plastic Gloves",
      project4Desc: "Disposable plastic gloves for food and medical use.",
      project5: "Plastic Aprons",
      project5Desc: "Disposable plastic aprons for food and medical use.",
      project6: "Shipping and Mailing Bags",
      project6Desc: "High-quality shipping and mailing bags for e-commerce and postal services.",
    },
    ar: {
      title: "امتيازنا في التعبئة والتغليف",
      description:
        "اكتشف مجموعة من حلول التعبئة والتغليف المبتكرة، من أكياس البلاستيك عالية الجودة إلى لفائف التغليف المتقدمة. نقدم خدماتنا لعدة صناعات مع دقة واهتمام بالاستدامة.",
      project1: "أكياس القمامة",
      project1Desc: "أكياس قمامة عالية الجودة بمختلف الأحجام والألوان للاستخدام السكني والتجاري.",
      project2: "أكياس تغليف مع سحاب",
      project2Desc: "أكياس تغليف مخصصة مع سحاب لتخزين ونقل الطعام والمنتجات الأخرى.",
      project3: "لفائف القمامة",
      project3Desc: "لفائف قمامة بمختلف الأحجام والألوان للاستخدام السكني والتجاري.",
      project4: "قفازات بلاستيكية",
      project4Desc: "قفازات بلاستيكية للاستخدام الطبي والغذائي.",
      project5: "مرايل بلاستيكية",
      project5Desc: "مرايل بلاستيكية للاستخدام الطبي والغذائي.",
      project6: "أكياس الشحن والبريد",
      project6Desc: "أكياس شحن وبريد عالية الجودة لخدمات التجارة الإلكترونية والبريد.",
    },
  };

  const { title, description, project1, project1Desc, project2, project2Desc, project3, project3Desc, project4, project4Desc, project5, project5Desc, project6, project6Desc } = translations[language];

  return (
    <Wrapper id="projects">
      <div className="whiteBg">
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">{title}</h1>
            <p className="font13">{description}</p>
          </HeaderInfo>
          <div className="row textCenter">
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <ProjectBox
                img={language === "en" ? ProjectImg9 : ProjectImg1}
                title={project1}
                text={project1Desc}
              />
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <ProjectBox
                img={language === "en" ? ProjectImg10 : ProjectImg2}
                title={project2}
                text={project2Desc}
              />
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <ProjectBox
                img={language === "en" ? ProjectImg11 : ProjectImg3}
                title={project3}
                text={project3Desc}
              />
            </div>
          </div>
          <div className="row textCenter">
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <ProjectBox
                img={language === "en" ? ProjectImg12 : ProjectImg6}
                title={project4}
                text={project4Desc}
              />
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <ProjectBox
                img={language === "en" ? ProjectImg14 : ProjectImg7}
                title={project5}
                text={project5Desc}
              />
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <ProjectBox
                img={language === "en" ? ProjectImg13 : ProjectImg8}
                title={project6}
                text={project6Desc}
              />
            </div>
          </div>
          <div style={{ paddingBottom: "2rem" }}></div>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
`;

const HeaderInfo = styled.div`
  @media (max-width: 860px) {
    text-align: center;
  }
`;
